import { z } from "zod";

const formEditOtherPartnerSchema = z.object({
  vlogaID: z
    .number()
    .nullable()
    .refine((val) => val !== null, {
      message: "Izberite vlogo partnerja",
    }),

  vodjaProjekta: z.string().optional(),
  kontaktnaOseba: z.string().optional(),
});

export default formEditOtherPartnerSchema;
